import { PrivateInterceptor } from '../../../interceptors/PrivateInterceptor'
//***


export const getInvoicesCustomer = async (IdCustomer) =>{
    
    const result = await PrivateInterceptor(`Ventas/Facturas/InvoicesCustomer/${IdCustomer}`, 'GET');
    return result;
}




export const getInvoicesCustomerDates = async (dates, IdCustomer) =>{
    

    const result = await PrivateInterceptor(`Ventas/Facturas/facturasFechasCliente`, 'POST', {FechaInicio :dates[0], FechaFinal: dates[1], IdCustomer: IdCustomer});
    return result;
}
